import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var Step = /*#__PURE__*/function () {
  function Step(_ref) {
    var id = _ref.id,
      slug = _ref.slug,
      props = _ref.props,
      image = _ref.image,
      component = _ref.component,
      isOptional = _ref.isOptional,
      isComplete = _ref.isComplete;
    _classCallCheck(this, Step);
    this.id = id;
    this.slug = slug || id;
    this.props = props;
    this.image = image;
    this.component = component;
    this.isOptional = !!isOptional;
    this.isComplete = isComplete;
    this.prev = null;
    this.next = null;
  }
  _createClass(Step, [{
    key: "setPrev",
    value: function setPrev(step) {
      this.prev = step;
    }
  }, {
    key: "setNext",
    value: function setNext(step) {
      this.next = step;
    }
  }]);
  return Step;
}();
export { Step as default };